import { DisplayPosition } from '@/type/display-position';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
    ],
    title: '日期范围选择器',
    componentName: 'CnDateRangePickerPro',
    getPrototypeList: () => {
        return [
        // getDatePrecisionSetterSnippet()
        // {
        //   name: 'showTime',
        //   title: '显示时间',
        //   display: 'inline',
        //   setter: 'BoolSetter',
        // },
        ];
    },
};
